import { IFormLabel, IFormDefinition, pascalToCameCasePropertyPath } from "@ngt/opms";
import { useMemo } from "react";


export const useEConsentFormLabels = (labels?: IFormLabel[], formDefinition?: IFormDefinition) => {

    return useMemo(() => {
        const convertedLabels: IFormLabel[] = [];

        if (labels) {
            for (let x of labels) {
                convertedLabels.push({
                    propertyPath: pascalToCameCasePropertyPath(x.propertyPath!),
                    label: x.label,
                    detailedLabel: x.detailedLabel
                })
            }

            return convertedLabels;
        }

        if (!formDefinition || !formDefinition.properties) {
            return convertedLabels;
        }

        for (let x of formDefinition.properties) {
            convertedLabels.push({
                propertyPath: pascalToCameCasePropertyPath(x.propertyName!),
                label: x.label,
                detailedLabel: x.detailedLabel
            })
        }

        if (formDefinition?.subformProperties) {
            for (let key of Object.keys(formDefinition.subformProperties)) {
                for (let p of formDefinition.subformProperties[key]) {
                    convertedLabels.push({
                        propertyPath: pascalToCameCasePropertyPath(`${key}.${p.propertyName}`),
                        label: p.label,
                        detailedLabel: p.detailedLabel
                    });
                }
            }
        }

        return convertedLabels;
    }, [formDefinition, labels])
};

export default useEConsentFormLabels;